import { z } from 'zod';

import { AchCode } from '../ach';
import { AchBatchTransactionId, BorrowerAchAccountId, BorrowerId, CompanyAchAccountId } from '../BrandedIds';

export const NachaPaymentInfo = z.object({
  transactionId: AchBatchTransactionId,
  borrowerId: BorrowerId,
  borrowerAchAccountId: BorrowerAchAccountId,
  companyAchAccountId: CompanyAchAccountId,
  amount: z.number(),
  achCode: AchCode,
  description: z.string(),
});
export type NachaPaymentInfo = z.infer<typeof NachaPaymentInfo>;
